import { useEffect } from "react";

import { generatePath, useNavigate, useParams } from "react-router-dom";
import TeamService from "../../service/TeamService";
import { ROUTES } from "../../constant/common.constant";
import { useTeam } from "../../context/Team";
import { useProject } from "../../context/Project";

export const JoinTeamWithTokenContainer = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const { refetchTeam, refetchTeams } = useTeam();
  const { refetchProject } = useProject();

  useEffect(() => {
    const tokenAction = async (token: string) => {
      try {
        const {
          data: { data: teamId },
        } = await TeamService.joinUserToTeamWithInviteToken(token);

        //Since we added the user to the team, we must refresh the teams's store and projects's store
        await Promise.all([refetchTeam(), refetchTeams()]);

        navigate(generatePath(ROUTES.TEAM, { teamId }));
      } catch (error) {
        navigate(ROUTES.LOGIN, { state: { inviteLinkExpired: true } });
      }
    };

    if (token) {
      tokenAction(token);
    }
  }, [token, navigate, refetchProject, refetchTeam, refetchTeams]);

  return <div>Redirecting...</div>;
};
